import axios from 'axios';
import * as utils from '../../../../utils/common';

let createOrUpdateEmailWithGmail = function (code) {
    return new Promise(async (resolve, reject) => {
        axios
            .post(
                `${utils.getServerURL()}/emailWithGmailApi/emailWithGmailMaster`,
                { code: code },
                {
                    headers: { token: utils.getAPIToken() }
                }
            )
            .then((responseData) => {
                resolve(responseData);
            })
            .catch((err) => {
                console.log('### err-', err.response);
                reject(err);
            });
    });
};

let getEmailWithGmailMaster = function () {
    return new Promise(async (resolve, reject) => {
        axios
            .get(`${utils.getServerURL()}/emailWithGmailApi/getEmailWithGmailMaster`, {
                headers: { token: utils.getAPIToken() }
            })
            .then((responseData) => {
                resolve(responseData);
            })
            .catch((err) => {
                console.log('### err-', err.response);
                reject(err);
            });
    });
};

let disconnectGmail = function (id) {
    return new Promise(async (resolve, reject) => {
        axios
            .patch(
                `${utils.getServerURL()}/emailWithGmailApi/disconnectEmailWithGmailMaster`,
                { id: id },
                {
                    headers: { token: utils.getAPIToken() }
                }
            )
            .then((responseData) => {
                resolve(responseData);
            })
            .catch((err) => {
                console.log('### err-', err.response);
                reject(err);
            });
    });
};

export default {
    createOrUpdateEmailWithGmail,
    getEmailWithGmailMaster,
    disconnectGmail
};
